import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const SocialShare = ({ fileName, veracity }) => {
  const shareText = `I just analyzed "${fileName}" using ExifInvestigator. Veracity Score: ${veracity}%. Check image authenticity locally at takedowntaskforce.com!`;
  const url = "https://takedowntaskforce.com";

  const platforms = [
    {
      name: 'Twitter',
      icon: FiIcons.FiTwitter,
      href: `https://twitter.com/intent/tweet?text=${encodeURIComponent(shareText)}`,
      color: 'bg-[#1DA1F2]'
    },
    {
      name: 'LinkedIn',
      icon: FiIcons.FiLinkedin,
      href: `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`,
      color: 'bg-[#0A66C2]'
    },
    {
      name: 'Facebook',
      icon: FiIcons.FiFacebook,
      href: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`,
      color: 'bg-[#1877F2]'
    }
  ];

  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: 'Exif Forensic Report',
          text: shareText,
          url: url,
        });
      } catch (err) {
        console.error("Error sharing:", err);
      }
    }
  };

  return (
    <div className="mt-6 pt-6 border-t border-gray-100">
      <p className="text-xs font-bold text-gray-400 uppercase tracking-widest mb-3">Share Analysis</p>
      <div className="flex gap-2">
        {platforms.map((p) => (
          <a
            key={p.name}
            href={p.href}
            target="_blank"
            rel="noopener noreferrer"
            className={`${p.color} text-white p-2.5 rounded-lg hover:opacity-90 transition shadow-sm`}
            title={`Share on ${p.name}`}
          >
            <SafeIcon icon={p.icon} className="text-lg" />
          </a>
        ))}
        <button
          onClick={handleShare}
          className="bg-gray-100 text-gray-600 p-2.5 rounded-lg hover:bg-gray-200 transition shadow-sm"
          title="More sharing options"
        >
          <SafeIcon icon={FiIcons.FiShare2} className="text-lg" />
        </button>
      </div>
    </div>
  );
};

export default SocialShare;